module.exports = __webpack_public_path__ + "static/media/badge.3a1ef795.svg";